import { render } from "./uploadUnits.vue?vue&type=template&id=61c61374&scoped=true"
import script from "./uploadUnits.vue?vue&type=script&lang=js"
export * from "./uploadUnits.vue?vue&type=script&lang=js"

import "./uploadUnits.vue?vue&type=style&index=0&id=61c61374&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c61374"]])

export default __exports__